import { ThemeEvents } from '@theme/events';

class BlockPaginatedList extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.button = null;
    this.cards = [];
    this.pageSize = 6;
    this.currentPage = 1;
  }

  connectedCallback() {
    this.init();
    document.addEventListener(ThemeEvents.SectionLoad, this.onSectionLoad);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.loadNext);
    document.removeEventListener(ThemeEvents.SectionLoad, this.onSectionLoad);
  }

  init = () => {
    this.container = this.querySelector('.listing-wrapper');
    if (!this.container) return;

    this.button = this.querySelector('.load-more');
    this.cards = [...this.container.querySelectorAll('.card-listing-card.generic')];
    this.pageSize = Number(this.container.dataset.pageSize || 9);

    this.currentPage = this.getPageFromURL();

    this.restorePages();

    // Load more click
    if (this.button) this.button.addEventListener('click', this.loadNext);
  }

  onSectionLoad = (event) => {
    if (!event.detail.section.contains(this)) return;
    this.init();
  }

  getPageFromURL() {
    const params = new URLSearchParams(window.location.search);
    const sectionId = this.getAttribute('section-id') || this.dataset.sectionId;
    const pageParam = params.get('page');
    const sectionParam = params.get('section');

    if (sectionParam && sectionParam !== sectionId) return 1;

    const page = Number(pageParam);
    return page > 0 ? page : 1;
  }

  restorePages() {
    const visibleCount = this.currentPage * this.pageSize;
    this.cards.slice(0, visibleCount).forEach((card) => {
      card.classList.remove('hidden');
    });
    this.updateButton();
  }

  loadNext = () => {
    this.button?.setAttribute('disabled', 'disabled');
    this.button?.setAttribute('aria-disabled', 'true');
    this.button?.classList.add('loading');
    
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    const nextCards = this.cards.slice(start, end);

    setTimeout(() => {
      this.button?.removeAttribute('disabled');
      this.button?.setAttribute('aria-disabled', 'false');
      this.button?.classList.remove('loading');
    }, 300);

    nextCards.forEach((card, i) => {
      card.classList.remove('hidden');
    });

    this.currentPage++;
    this.pushState();
    this.updateButton();
  }

  pushState() {
    const url = new URL(window.location.href);
    const sectionId = this.getAttribute('section-id') || this.dataset.sectionId;

    url.searchParams.set('page', this.currentPage);
    url.searchParams.set('section', sectionId);

    history.pushState({ page: this.currentPage, section: sectionId }, '', url);
  }

  updateButton() {
    if (this.currentPage * this.pageSize >= this.cards.length) {
      this.button?.remove();
    }
  }
}

if (!customElements.get('block-paginated-list')) {
  customElements.define('block-paginated-list', BlockPaginatedList);
}
